import { CategoryBadge } from "@/components/common";
import { formatPercentage } from "../../domains/formatting";
import { CATEGORY_ORDER, formatCount } from "./metrics-drawer.utils";

const buildPercentage = (completed, total) =>
  total > 0 ? (completed / total) * 100 : 0;

const TargetSetupCategoryProgressContent = ({ items }) => {
  if (!Array.isArray(items)) {
    return null;
  }

  const itemsByCategory = new Map(items.map((item) => [item.category, item]));

  return (
    <div className="space-y-3">
      <div className="space-y-3">
        {CATEGORY_ORDER.map((category) => {
          const item = itemsByCategory.get(category) ?? {
            completed: 0,
            total: 0,
          };
          const percentage = buildPercentage(item.completed, item.total);

          return (
            <div
              key={category}
              className="rounded-lg border border-border/70 bg-card px-3 py-2.5 shadow-sm"
            >
              <div className="flex items-center justify-between gap-3">
                <CategoryBadge category={category} />

                <span className="text-sm font-semibold text-foreground">
                  {formatPercentage(percentage)}
                </span>
              </div>

              <p className="mt-2 text-[11px] text-muted-foreground">
                {formatCount(item.completed)} with target /{" "}
                {formatCount(item.total)} assigned
              </p>

              <div className="mt-2.5 h-2 overflow-hidden rounded-full bg-muted">
                <div
                  className="h-full rounded-full bg-[hsl(var(--chart-1))] transition-[width] duration-300 ease-out"
                  style={{ width: `${Math.min(percentage, 100)}%` }}
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

const TargetSetupCategoryProgressSkeleton = () => (
  <div className="space-y-3">
    {CATEGORY_ORDER.map((category) => (
      <div
        key={category}
        className="rounded-lg border border-border/70 bg-card px-3 py-2.5 shadow-sm"
      >
        <div className="flex items-center justify-between gap-3">
          <div className="h-7 w-28 animate-pulse rounded-full bg-muted" />
          <div className="h-5 w-12 animate-pulse rounded bg-muted" />
        </div>

        <div className="mt-2 h-3 w-36 animate-pulse rounded bg-muted" />

        <div className="mt-2.5 h-2 overflow-hidden rounded-full bg-muted">
          <div className="h-full w-1/2 animate-pulse rounded-full bg-muted-foreground/25" />
        </div>
      </div>
    ))}
  </div>
);

const TargetSetupCategoryProgress = ({ items, loading = false }) => {
  if (loading) {
    return <TargetSetupCategoryProgressSkeleton />;
  }

  return <TargetSetupCategoryProgressContent items={items} />;
};

export default TargetSetupCategoryProgress;
